import React, {useEffect} from "react";

import cx from 'classnames'
import styles from './FontCard.module.css'
import Card from "../../../components/Card";
import {Font} from "../../../types/Font";

const FontCard: React.FC<Font & {
    onClick: (font: Font) => void
    chosen: boolean
}> = (
    {
        id,
        name,
        path,
        active,
        onClick,
        chosen
    }
) => {

    useEffect(() => {
        if (!name || !path) return

        const fontFace = new FontFace(name, `url(${path})`)
        fontFace.load().then((f) => {
            document.fonts.add(f)
        })
    }, [name, path])

    return (
        <Card
            key={id}
            style={{background: chosen ? '#F1F1F1' : '#FFF'}}
            onClick={() => onClick({id, name, active, path})}
        >
            <div className={cx(styles['card-inner-wrapper'])}>
                <div title={name} className={cx(styles['font-family-wrapper'])} style={{fontFamily: name}}>
                    Aa
                </div>
            </div>
        </Card>
    )
}

export default FontCard
